module.exports = __webpack_public_path__ + "img/vip.ab6953df.png";